
<template>

  <body>
   <div id="header">
    <div class="header-inner">
      <h1><a href="index.html"><img width="382" height="56" src="../../static/images/logo.png" alt="小白保险logo" title="小白保险"/></a></h1>
      <a id="zysq-introduce" href="http://mp.weixin.qq.com/s?__biz=MzAxNzA5Mjc5Ng==&mid=201323575&idx=1&sn=619210f13033538428fa23ae023508e8&scene=1#rd" target="_blank">展业神器简介</a>
    </div>
  </div>
  <div class="clearfix"></div><!--ie7兼容-->
  <!--内容-->
   <div id="content">
     <div id="about-content" class="join-content clearfix">
       <div class="map">
         <div class="address-info">
           <div class="m2">
             <h2>广州米兔网络科技有限公司</h2>
             <ul class="m2-info">
               <li class="m2-info-li clearfix">
                 <div class="m2-info-tit">地址：</div>
                 <div class="m2-address">广州市越秀区东风中路515号东照大厦2006室</div>
               </li>
             </ul>
             <ul class="m2-info">
               <li class="m2-info-li clearfix">
                 <div class="m2-info-tit">邮编：</div>
                 <div>510030</div>
               </li>
             </ul>
             <ul class="m2-info">
               <li class="m2-info-li clearfix">
                 <div class="m2-info-tit">热线：</div>
                 <div>020-83274011</div>
               </li>
             </ul>
           </div>
           <div class="m2 zx">
             <h2>正迅保险经纪有限公司</h2>
             <ul class="m2-info">
               <li class="m2-info-li clearfix">
                 <div class="m2-info-tit">地址：</div>
                 <div class="m2-address">广州市黄埔区科学大道249号706房</div>
               </li>
             </ul>
             <ul class="m2-info">
               <li class="m2-info-li clearfix">
                 <div class="m2-info-tit">邮编：</div>
                 <div>510030</div>
               </li>
             </ul>
             <ul class="m2-info">
               <li class="m2-info-li clearfix">
                 <div class="m2-info-tit">热线：</div>
                 <div>020-62324288</div>
               </li>
             </ul>
           </div>
         </div>
       </div>
       <div class="kf info-help">
         <h3>客服帮助</h3>
         <p>为及时解决您的问题，建议您通过客户端提交意见反馈，我们会尽快在24小时内受理您的问题</p>
         <p>1. 客服热线：020-83274011（服务时间周一至周五 09:30-17:30）</p>
         <p>2. 在小白保险官方微信公众号留言 @小白保险</p>
       </div>
       <div class="kf info-help">
         <h3>公司资质</h3>
         <p>保险经纪业务许可证：260591000000800 </p>
         <p>广州米兔网络科技有限公司</p>
       </div>
     </div>
   </div>
  </body>
</template>
<script>
    export default {
        name: "contact",
        data() {
            return{
            }

        },
        methods: {
        },
        mounted() {

        }
    }
</script>

<style src="../../static/css/rcMain/common.css" ></style>
<style scoped>

  body {
    width: 100%;
    height: 100%;
    zoom: 1;
    position: relative
  }

  #content {
    padding: 130px 0 60px;
    margin: 0 auto;
    height: calc(100vh - 70px);
  }

  .map {
    width: 1000px;
    height: 400px;
    background: url("../../static/images/map2.png") no-repeat;
    position: relative
  }

  .map img {
    vertical-align: middle;
  }

  .address-info {
    position: absolute;
    top: 0px;
    left: 50px;
    width: 250px;
    height: 290px;
    padding: 35px 25px;
    color: #ffffff;
  }

  .address-info h2 {
    font-size: 18px;
    font-weight: bolder;
    text-align: left;
  }

  .address-info div {
    float: left;
    line-height: 20px;
    font-size: 14px
  }

  .m2 h2 {
    margin-bottom: 20px
  }

  .zx {
    margin-top: 30px;
    *margin-top: 15px
  }

  .m2-info {
    margin: 5px 0;
  }

  .m2-info-tit {
    width: 48px
  }

  .m2-address {
    width: 202px
  }

  .info-help {
    margin: 40px 0 0 0
  }

  .info-help h3 {
    text-align: left;
    margin-bottom: 10px;
    color: #000000;
    font-size: 16px
  }

  .info-help p {
    line-height: 22px;
  }

  #header {
    background-color: #ffffff
  }

  .ie8 #content {
    margin-top: 100px
  }

  .ie6 #content {
    margin-top: 100px !important;
    position: relative;
    zoom: 1
  }

  .ie6 #footer {
    position: fixed;
    zoom: 1;
    bottom: 0px;
  }

  .ie6 .ban {
    display: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/contact.vue